(ns pfo.label.controller (:require
                          [pfo.api :as api  :refer [process-error]]
                          [promesa.core :as p]
                          [pfo.util :as util]
                          [keechma.next.controller :as ctrl]))

(derive :label-list :keechma/controller)
(defmethod ctrl/handle :label-list
  [{:keys [state*] :as ctrl} event {:keys [family-id page order id name errors-atom on-success on-error paginate object-type]}]
  (case event
    :load (->>
            (api/ajaxp "/label/" {:params (util/remove-nil-values {:family_id family-id
                                                                   :page page
                                                                   :paginate (if paginate "yes" "no")
                                                                   :order order
                                                                   :object_type object-type})})
            (p/map (fn [labels] (ctrl/transact ctrl #(reset! state* labels))))
            (process-error))
    :update (->>
              (api/ajaxp (str "/label/" id "/") {:method :post
                                                 :params (util/remove-nil-values {:family_id family-id
                                                                                  :name name
                                                                                  :object_type object-type})})
              (p/map (or on-success (fn [_])))
              (p/error (or on-error (fn [error-response] (throw error-response))))
              (process-error errors-atom))
    :add (->>
           (api/ajaxp (str "/label/") {:method :post
                                       :params (util/remove-nil-values {:family_id family-id
                                                                        :name name
                                                                        :object_type object-type})})
           (p/map (or on-success (fn [_])))
           (p/error (or on-error (fn [error-response] (throw error-response))))
           (process-error errors-atom))
    :delete (->>
              (api/ajaxp (str "/label/" id "/") {:method :delete})
              (p/map (or on-success (fn [_])))
              (p/error (or on-error (fn [error-response] (throw error-response))))
              (process-error errors-atom))
    :clear (reset! state* nil)
    nil))
